import { render, staticRenderFns } from "./CbsGroupbyOperands.vue?vue&type=template&id=afa5a63a&scoped=true"
import script from "./CbsGroupbyOperands.vue?vue&type=script&lang=js"
export * from "./CbsGroupbyOperands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa5a63a",
  null
  
)

export default component.exports